//bao migrate skip
import template from "./select-multiple.html";
import * as SelectMultipleModule from "./select-multiple-module";
import * as ko from "knockout";
export default {
    viewModel: {
        createViewModel: (params, componentInfo) => new SelectMultipleModule.SelectMultipleComponent(params, componentInfo.element)
    },
    template: template
};